import { render } from "./ColorSelectControl.vue?vue&type=template&id=57f79845&scoped=true"
import script from "./ColorSelectControl.vue?vue&type=script&lang=js"
export * from "./ColorSelectControl.vue?vue&type=script&lang=js"

import "./ColorSelectControl.vue?vue&type=style&index=0&id=57f79845&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f79845"]])

export default __exports__